module.exports = __webpack_public_path__ + "static/media/pe.b32ab40d.webp";